/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import Modal from "../modal/Modal";

const Overview = ({
  selectedApp,
  setShowUploadFile,
  showUploadFile,
  handleDocumentUpload,
  handleSaveFile,
  idFile,
  loader
}) => {
  const renderCause = (cause, index) => (
    <div
      key={index}
      className="inline-flex justify-center rounded-md bg-green-300 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300"
    >
      {cause}
    </div>
  );

  return (
    <>
      <div className="mt-10 col-span-4">
        <div className="grid grid-cols-1 divide-y">
          <div className="mb-3">
            <h1 className="font-bold text-xl">Causes & Tags</h1>
            <div className="mt-7">
              <div className="mr-2 inline-flex justify-center rounded-md  px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 ">
                <span className="capitalize">
                  {selectedApp?.type} Scholar
                </span>
              </div>

              {selectedApp?.causes?.map((cause, index) => {
                return renderCause(cause, index);
              })}
              {selectedApp?.category && (
                <div className="mr-2 inline-flex justify-center rounded-md bg-green-300 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 ">
                  <span className="capitalize">
                    {selectedApp?.category}
                  </span>
                </div>
              )}
            </div>
          </div>
          <div>
            <div>
              <h1 className="mt-3 mb-3 font-bold text-xl">
                About {selectedApp?.orgName}
              </h1>
              <p className="mb-4">{selectedApp?.orgMission}</p>
            </div>
          </div>
          {/* Info Cards */}
        </div>
        <div className="mt-4 mb-15 ">
          <ul role="list" className=" grid grid-cols-2 gap-6 ">
            {selectedApp?.type === "give" && (
              <li
                key={selectedApp?.email}
                className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow"
              >
                <div className=" w-full items-center justify-between space-x-6 p-6">
                  <div className=" ">
                    <div className="flex items-center space-x-3 divide-y divide-gray-200">
                      <h3 className=" text-sm font-medium text-primary-500">
                        501C3 Document
                      </h3>
                    </div>

                    <div>
                      {selectedApp?.idNumber.idReason === "No" && (
                        <>
                          <h3 className=" text-sm font-medium ">
                            Reason organization does not have a 501C3:
                          </h3>
                          <p className="mt-1 text-sm text-gray-500">
                            {selectedApp?.idNumber.idReason}
                          </p>
                        </>
                      )}

                      {showUploadFile && (
                        <Modal>
                          <div className="fixed z-10 inset-0 overflow-y-auto">
                            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                              {/* <!-- This element is to trick the browser into centering the modal contents. --> */}
                              <span
                                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                                aria-hidden="true"
                              >
                                &#8203;
                              </span>
                              <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 space-y-4">
                                <div className="w-full flex justify-between items-center">
                                  <div>
                                    <button
                                      className="cursor-pointer"
                                      onClick={() =>
                                        setShowUploadFile(false)
                                      }
                                    >
                                      <span className="material-icons-outlined text-4xl">
                                        chevron_left
                                      </span>
                                    </button>
                                    <p className="mb-3">
                                      Upload Document
                                    </p>
                                    <input
                                      onChange={handleDocumentUpload}
                                      type="file"
                                      id="giveDocument"
                                    />
                                  </div>
                                  <div>
                                    <button
                                      className=" relative rounded shadow-sm px-1.5 py-1.5 text-white  bg-success-800"
                                      onClick={() => {
                                        handleSaveFile(payload);
                                      }}
                                      disabled={!(loader === false)}
                                    >
                                      {loader ? (
                                        <span>Uploading..</span>
                                      ) : (
                                        <span>Save File</span>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Modal>
                      )}
                    </div>
                  </div>
                </div>

                <div className="pl-2 pr-4 flex justify-between">
                  <div className="">
                    <button
                      className="cursor-pointer px-1 py-1  "
                      size="md"
                      onClick={() => setShowUploadFile(true)}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="px-1 py-1 ">
                    {selectedApp?.idNumber.idFile?.large?.url ? (
                      <div className="justify-end">
                        <Link
                          to={`/impact/501file/${selectedApp?.id}`}
                          target="_blank"
                        >
                          View
                        </Link>
                      </div>
                    ) : selectedApp?.idNumber.idFile?.idFile?.url ? (
                      <Link
                        to={selectedApp?.idNumber.idFile.idFile.url}
                        target="_blank"
                      >
                        Download
                      </Link>
                    ) : null}
                  </div>
                </div>
              </li>
            )}
            {selectedApp?.type === "boost" &&
              selectedApp?.businessPdf ? (
              <li className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
                <div className="flex w-full items-center justify-between space-x-6 p-6">
                  <div className="flex-1 truncate">
                    <div className="flex items-center space-x-3">
                      <h3 className="truncate text-sm font-medium text-primary-500">
                        Proof of Business
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end pr-4">
                  <Link
                    to={selectedApp?.businessPdf.businessPdf.url}
                    target="_blank"
                  >
                    Download
                  </Link>
                </div>
              </li>
            ) : null}
            {/* <li className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
											<div className="flex w-full items-center justify-between space-x-6 p-6">
												<div className="flex-1 truncate">
													<div className="flex items-center space-x-3">
														<h3 className="truncate text-sm font-medium text-primary-500">
														
														</h3>
													</div>
													
												</div>
											</div>
											<div className="flex justify-end pr-4">
												<Link to={`/file/${selectedApp?.id}`} target="_blank">
													View
												</Link>
											</div>
										</li> */}
          </ul>
        </div>
        <div className="mt-10 mb-10">
          <h1 className="font-bold text-black mb-4">
            Impact Stories from {selectedApp?.orgName}
          </h1>
          <p>No Submitted Stories</p>
        </div>
      </div>
    </>
  );
};

export default Overview;